import { Component, Input, ContentChild, TemplateRef } from '@angular/core';

@Component({
  selector: 'exception',
  template: `
  <div class="img-block">
    <div class="img" [ngStyle]="{'background-image': 'url(' + _img + ')'}"></div>
  </div>
  <div class="cont">
    <h1 [innerHTML]="_title"></h1>
    <div class="desc" [innerHTML]="_desc"></div>
    <ng-template #defaultActions>
      <button nz-button [routerLink]="['/']" [nzType]="'primary'">è¿åé¦é¡µ</button>
      <ng-content></ng-content>
    </ng-template>
    <div class="actions" *ngIf="actions; else defaultActions">
      <ng-template [ngTemplateOutlet]="actions"></ng-template>
      <ng-content></ng-content>
    </div>
  </div>
  `,
  host: { '[class.ad-exception]': 'true' },
  preserveWhitespaces: false,
})
export class ExceptionComponent {
  _img = '';
  _title = '';
  _desc = '';

  @Input()
  set type(value: 403 | 404 | 500) {
    const item = {
      403: {
        img:
          'https://gw.alipayobjects.com/zos/rmsportal/wZcnGqRDyhPOEYFcZDnb.svg',
        title: '403',
        desc: 'æ±æ­ï¼ä½ æ æè®¿é®è¯¥é¡µé¢',
      },
      404: {
        img:
          'https://gw.alipayobjects.com/zos/rmsportal/KpnpchXsobRgLElEozzI.svg',
        title: '404',
        desc: 'æ±æ­ï¼ä½ è®¿é®çé¡µé¢ä¸å­å¨',
      },
      500: {
        img:
          'https://gw.alipayobjects.com/zos/rmsportal/RVRUAYdCGeYNBWoKiIwB.svg',
        title: '500',
        desc: 'æ±æ­ï¼æå¡å¨åºéäº',
      },
    }[value];

    if (!item) return;

    this._img = item.img;
    this._title = item.title;
    this._desc = item.desc;
  }

  @Input()
  set img(value) {
    this._img = value;
  }
  @Input()
  set title(value) {
    this._title = value;
  }
  @Input()
  set desc(value) {
    this._desc = value;
  }

  @ContentChild('actions') actions: TemplateRef<any>;
}
